import React from "react";
import styles from "assets/jss/material-dashboard-react/components/tablebaocaoStyle.js";
const useStyles = makeStyles(styles);
import { makeStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import Config from "conFig.js";
const BCXebuyttable = React.memo(function BCXebuyttable(props) {
  const classes = useStyles();
  const { thangnam } = props;
  const [sotuyen_khaithac, setSotuyen_khaithac] = React.useState(0);
  const [sochuyenthuchien, setSochuyenthuchien] = React.useState(0);
  const [sotuyen_trogia, setSotuyen_trogia] = React.useState(0);
  const [sophuongtien, setSophuongtien] = React.useState(0);
  const [tylethuchien, setTylethuchien] = React.useState(0);
  const [sokhachvanchuyen, setSokhachvanchuyen] = React.useState(0);
  const [trogia, setTrogia] = React.useState(0);
  const token = localStorage.getItem("token");
  var username = localStorage.getItem("username");
  var obj = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };
  const getbaocao = () => {
    if (thangnam) {
      var thang = String(thangnam.$M + 1).padStart(2, "0") + "/" + thangnam.$y;
      var url =
        Config.backend +
        "/api/Phuongtien/bcslthbuyt?thang=" +
        thang +
        "&username=" +
        username;
      fetch(url, obj)
        .then((res) => res.json())
        .then((data) => {
          if (data.length > 0) {
            setSotuyen_khaithac(data[0].sotuyen_khaithac);
            setSochuyenthuchien(data[0].sochuyenthuchien);
            setSotuyen_trogia(data[0].sotuyen_trogia);
            setSophuongtien(data[0].sophuongtien);
            setTylethuchien(data[0].tylethuchien);
            setSokhachvanchuyen(data[0].sokhachvanchuyen);
            setTrogia(data[0].trogia);
          }
        })
        .catch((error) => {
          console.error("Error fetching data: ", error);
        });
    }
  };
  React.useEffect(() => {
    getbaocao();
  }, [thangnam]);
  const renderTableHead = () => {
    return (
      <thead>
        <tr>
          <th className={classes.tablebc_th}>TT</th>
          <th className={classes.tablebc_th}>Chỉ tiêu</th>
          <th className={classes.tablebc_th}>Đon vị</th>
          <th className={classes.tablebc_th}>Số lượng</th>
        </tr>
      </thead>
    );
  };
  const renderTableBody = () => {
    return (
      <tbody>
        <tr>
          <td className={classes.tablebc_td}>1</td>
          <td className={classes.tablebc_td}>Số tuyến tham gia khai thác</td>
          <td className={classes.tablebc_td}>tuyến</td>
          <td className={classes.tablebc_td}>{sotuyen_khaithac}</td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}></td>
          <td className={classes.tablebc_td}>- Số tuyến có trợ giá</td>
          <td className={classes.tablebc_td}>tuyến</td>
          <td className={classes.tablebc_td}>{sotuyen_trogia}</td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}>2</td>
          <td className={classes.tablebc_td}>Số lượng phương tiện</td>
          <td className={classes.tablebc_td}>xe</td>
          <td className={classes.tablebc_td}>{sophuongtien}</td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}>3</td>
          <td className={classes.tablebc_td}>Tổng số chuyến xe thực hiện</td>
          <td className={classes.tablebc_td}>chuyến</td>
          <td className={classes.tablebc_td}>{sochuyenthuchien}</td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}>4</td>
          <td className={classes.tablebc_td}>Tỷ lệ thực hiện/kế hoạch</td>
          <td className={classes.tablebc_td}>%</td>
          <td className={classes.tablebc_td}>{tylethuchien}</td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}>5</td>
          <td className={classes.tablebc_td}>Sản lượng khách vận chuyển</td>
          <td className={classes.tablebc_td}>lượt khách</td>
          <td className={classes.tablebc_td}>{sokhachvanchuyen}</td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}>6</td>
          <td className={classes.tablebc_td}>Trợ giá (nếu có)</td>
          <td className={classes.tablebc_td}>1000đ</td>
          <td className={classes.tablebc_td}>{trogia}</td>
        </tr>
      </tbody>
    );
  };
  var tHead = renderTableHead();
  var tBody = renderTableBody();
  return (
    <div className={classes.table} style={{ height: "350px" }}>
      <table id="baocaoxebuyt" className={classes.tablebc}>
        {tHead}
        {tBody}
      </table>
    </div>
  );
});

BCXebuyttable.propTypes = {
  thangnam: PropTypes.object,
};
export default BCXebuyttable;
